import { PrivateInterceptor } from '../../Base/interceptors/PrivateInterceptor'


export const getEncabezadoSales = async(dates) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/EncabezadoPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}

export const getDetallesSales = async(dates) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/DetallesPorFechas','POST' ,{FechaInicio: dates[0],FechaFinal: dates[1] })
    return result
}

export const getOrdenVenta = async(IdSalesOrder) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/getOrdenVenta','POST' ,{IdSalesOrder})
    return result
}

export const getOrdenVentasDetalles = async(IdSalesOrder) =>{
    const result = await PrivateInterceptor('Ventas/SalesOrders/getOrdenVentasDetalles','POST' ,{IdSalesOrder})
    return result
}

export const getCartasCredito = async(IdCliente) =>{
    const result = await PrivateInterceptor(`Ventas/SalesOrders/CartasCliente/${IdCliente}`, 'GET')
    return result
}

export const postEstilosCartaCredito = async(Informacion) =>{
    const result = await PrivateInterceptor(`Ventas/SalesOrders/GuardarEstilo`, 'POST', Informacion)
    return result
}


export const getBalanceHilazaVenta = async(dates, IdEstado) =>{
    const result = await PrivateInterceptor(`Ventas/SalesOrders/BalanceHilazaVenta`, 'POST', {FechaInicio: dates[0],FechaFinal: dates[1], IdEstado })
    return result
}

